import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import vuetify from './plugins/vuetify'
import VueMeta from 'vue-meta'
import BeeComponents from '@beetronix/bee-components'
import VueEllipseProgress from 'vue-ellipse-progress';
import { API_URL } from './constants';
import * as types from './store/mutation-types';
import '@beetronix/bee-components/lib/css/index.css';
import i18n from './i18n'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import VueApexCharts from 'vue-apexcharts'
// import '@beetronix/bee-components/lib/css/index.css';
Vue.use(VueApexCharts)

Vue.config.productionTip = false
Vue.use(BeeComponents);
Vue.use(VueEllipseProgress);

Vue.component('apexchart', VueApexCharts)
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$requestStack = Vue.observable({
	stack: [],
	getRequest(key) {
		return this.stack.find(c => c.key === key) || { key: null, promise: null }
	},
	setRequest(entires) {
		let tempEntires;
		if (Array.isArray(entires)) {
			tempEntires = entires;
		} else {
			tempEntires = [{ key: entires.key, promise: entires.promise }]
		}
		tempEntires.forEach(entry => {
			if (!this.stack.find(c => c.key === entry.key)) {
				this.stack.push({ key: entry.key, promise: entry.promise });
				entry.promise.finally(() => {
					this.stack = this.stack.filter(c => c.key !== entry.key);
				})
			}
		})
	}
});

window.axios = axios.create({
	baseURL: API_URL
});

let controller = new AbortController();
const onceRequestStack = [];
window.axios.interceptors.request.use(configs => {
	if (configs.once) {	
		let query =
			configs.params
				? (
					(configs.params instanceof URLSearchParams
						? Array.from(configs.params.entries())
						: Object.entries(configs.params)
					).map(([key, value]) => `${key}=${value}`).join('&')
				)
				: null;
		query = query ? '?' + query : '';

		if (!onceRequestStack.includes(configs.url + query)) {
			onceRequestStack.push(configs.url + query)
		} else if (onceRequestStack.includes(configs.url + query)) {
			const controller = new AbortController();
			configs.signal = controller.signal;
			controller.abort();
		}
	} else {
		configs.signal = controller.signal;
	}
	return configs
});

window.axios.interceptors.response.use(
	response => {
		if (onceRequestStack.includes(response.config.url)) {
			onceRequestStack.splice(onceRequestStack.indexOf(response.config.url), 1)
		}
		return response;
	},
	error => {
		if (error.code === 'ERR_CANCELED') return Promise.reject(error);
		if (!error.config.preventHandling) {
			if (error.response.status === 401 && router.currentRoute.name !== 'login') {
				store.dispatch('auth/logout');
				store.dispatch('resetApplicationState');
				router.replace({ name: 'login' })
			}
			if (router.currentRoute.name !== 'login') {
				eventBus.$emit('show-snackbar', error.response.data.message, 'error');
			}
		}
		return Promise.reject(error)
	}
)

router.beforeEach((to, from, next) => {
	if (from && from.name !== 'login') {
		controller.abort();
		controller = new AbortController();
	}
	next();
})

window.moment = moment;

if ('auth' in localStorage) {
	window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = API_URL
	try {
		const auth = JSON.parse(localStorage.getItem('auth'));
		const authHeader = `Bearer ${auth.token}`;

		window.axios.defaults.headers.common.Authorization = authHeader;
		Promise.all([
			store.dispatch('auth/getSelf'),
			store.dispatch('entityType/fetchAll')
		])
			.then(() => {
				store.commit(`auth/${types.LOGIN}`, auth);
				store.dispatch('configuration/fetchAll')
			})
			.catch(() => {
				localStorage.removeItem('auth');
				router.replace({ name: 'login' });
			});
		if (store.state.auth.self.employeeId === null) {
			store.state.auth.self.employeeId = JSON.parse(localStorage.getItem('auth')).employeeId
		}
	} catch (e) {
		localStorage.removeItem('auth');
	}
} else {
	store.state.auth.youPermissions = {}
	router.replace({ name: 'login' });
}
Vue.use(VueMeta);
new Vue({
	router,
	store,
	vuetify,
	i18n,
	render: h => h(App)
}).$mount('#app')
